const SESSION_KEY = 'back_url';

const parseLocation = () => {
  const url = new URL(location.href.replace('#', ''));
  return url.searchParams.get('back_url');
};

export const getBackUrl = () => parseLocation() || sessionStorage.getItem(SESSION_KEY);

/**
 * Сохраняем back_url в sessionStorage, чтобы предотвратить его утерю пока гуляем по формам авторизации.
 */
export const saveBackUrl = () => {
  const url = parseLocation();
  if (!url) return;
  sessionStorage.setItem(SESSION_KEY, url);
};

export const clearBackUrl = () => {
  sessionStorage.removeItem(SESSION_KEY);
};

export const backUrlService = {
  get: getBackUrl,
  save: saveBackUrl,
  clear: clearBackUrl,
};
